import { createSelector } from 'reselect'

import { selectQbrState } from './selectQbrState'

export const selectQBRSOBAchievement = createSelector(
  [selectQbrState],
  (state) => state.selectedDocument?.SobAchievement || []
)
